export default "__VITE_ASSET__DCSJWFQC__"